import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';

@Component({
  selector: 'app-feature-toggle-panel',
  imports: [TranslatePipe],
  templateUrl: './feature-toggle-panel.component.html',
  styleUrl: './feature-toggle-panel.component.scss',
})
export class FeatureTogglePanelComponent {
  protected readonly featureToggle = inject(FeatureToggleService);
  protected readonly isOpen = signal(false);

  protected toggle(): void {
    this.isOpen.update(v => !v);
  }
}
